import React, { Component } from 'react'
import { Link } from 'react-router'
import PropTypes from 'prop-types'
import './index.scss'

class BtnText extends Component {
  // constructor (props) {
  //   super(props)
  // }

  render () {
    let toReturn = ''
    let classes = (this.props.className) ? this.props.className : ''
    if (this.props.to) {
      toReturn = (
        <Link className={`btn-text ${classes}`} to={this.props.to}>{this.props.children}</Link>
      )
    } else {
      toReturn = (
        <div className={`btn-text ${classes}`} onClick={this.props.onClickCallback}>{this.props.children}</div>
      )
    }
    return toReturn
  }
}

BtnText.propTypes = {
  to: PropTypes.string,
  onClickCallback: PropTypes.func,
  className: PropTypes.string
  // children: PropTypes.
}

export default BtnText



// WEBPACK FOOTER //
// ./src/components/BtnText/index.js